import React, { useState } from 'react';

import { connect, useDispatch } from 'react-redux';

import { isEqual } from 'lodash';

import clsx from 'clsx';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Checkbox from '@material-ui/core/Checkbox';

import { enqueueSnackbar } from '../../../actions/applicationMessageActions';
import * as configurationActions from '../../../actions/configurationActions';

import * as classes from './TileSelector.module.css';

const TileSelector = ({
    activeNavCompany,
    availableTiles,
    configurations,
    saveConfiguration,
    selectedTiles,
    setLoading,
    setSelectedTiles,
    updateAllConfigurations,
    updateConfiguration,
    userId,
    ...props
}) => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover' : undefined;

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = async () => {
        const tileConfiguration = configurations.find(item => item.viewKey === 'BOB|ExecutiveSummary');

        if (!selectedTiles.length) {
            dispatch(enqueueSnackbar('Please select at least 1 tile before saving.', 'error'));
            return;
        } else if (tileConfiguration) {
            if (tileConfiguration.viewData && tileConfiguration.viewData.selectedTiles) {
                if (isEqual(tileConfiguration.viewData.selectedTiles, selectedTiles)) {
                    setAnchorEl(null);
                    return;
                }
            }
        }

        setLoading(true);

        if (tileConfiguration) {
            tileConfiguration.viewData = JSON.stringify({ selectedTiles });
            await updateConfiguration(tileConfiguration.id, tileConfiguration);
            updateAllConfigurations(tileConfiguration.id, tileConfiguration);
        } else {
            let body = {
                name:         'Executive Summary Configuration',
                viewKey:      'BOB|ExecutiveSummary',
                entityId:     activeNavCompany.id,
                entityName:   activeNavCompany.name,
                isDefault:    false,
                viewData:     JSON.stringify({ selectedTiles }),
                sharedEmails: []
            };

            const id = await saveConfiguration(userId, body);
            if (id) {
                body.id = id;
                updateAllConfigurations(id, body);
            }
        }

        setAnchorEl(null);
        setLoading(false);
    };

    const handleExpandMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const isItemChecked = item => {
        if (selectedTiles.includes(item.value)) return true;
        return false;
    };

    const handleCheckbox = item => {
        if (selectedTiles.includes(item.value)) {
            let updatedTiles = [...selectedTiles];
            updatedTiles = updatedTiles.filter(tile => tile !== item.value);
            setSelectedTiles(updatedTiles);
        } else {
            let updatedTiles = [...selectedTiles];
            updatedTiles.push(item.value);
            setSelectedTiles(updatedTiles);
        }
    };

    const selectAllChecked = () => {
        if (selectedTiles.length === availableTiles.length) return true;
        return false;
    };

    const handleSelectAllCheckbox = () => {
        if (selectAllChecked()) {
            setSelectedTiles([]);
        } else {
            let tiles = [];
            availableTiles.forEach(item => {
                item.apps.forEach(app=>{
                    tiles.push(app.value);
                });
               
            });
            setSelectedTiles(tiles);
        }
    };

    return (
        <React.Fragment>
            <span role="none" onClick={handleClick}className={clsx('material-symbols-outlined', classes.Icon)}>
                settings
            </span>
            <Popper
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                className={classes.Menu}
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper
                        className={classes.Popper}
                        square
                    >
                        <div className={classes.List}>
                            <div className={classes.SelectAllContainer}>
                                <Checkbox
                                    style={{
                                        color:     'black',
                                        transform: 'scale(1.25)'
                                    }}
                                    onClick={handleSelectAllCheckbox}
                                    checked={selectAllChecked()}
                                />
                                Select All
                            </div>
                            {availableTiles.map((tile, index) => (
                                <List className={classes.MenuList}>
                                    <ListItem
                                        key={0}
                                        onClick={() => handleExpandMenu()}
                                        classes={{
                                            root: classes.MenuListItem
                                        }}
                                    >
                                        <i className={clsx(`fas fa-chevron-${menuOpen ? 'down' : 'up'}`, classes.icon)} aria-hidden="true" />
                                        <span className={classes.MenuItem}>{tile.group}</span>
                                    </ListItem>
                                    {
                                        menuOpen ?
                                            <List className={classes.TileList}>
                                                {tile.apps.map((app, index) => (
                                                    <ListItem
                                                        key={index}
                                                        onClick={() => handleCheckbox(app)}
                                                        classes={{
                                                            root: classes.ListItem
                                                        }}
                                                    >
                                                        <Checkbox
                                                            style={{
                                                                color:     'black',
                                                                transform: 'scale(1.25)'
                                                            }}
                                                            checked={isItemChecked(app)}
                                                        />
                                                        {app.value}
                                                    </ListItem>
                                                ))}
                                            </List>
                                            :
                                            null
                                    }
                                </List>
                            ))}
                        </div>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        configurations:   state.configurationData.allConfigurations,
        userId:           state.currentUser.id
    };
};

const mapDispatchToProps = {
    ...configurationActions
};

export default connect(mapStateToProps, mapDispatchToProps)(TileSelector);
